var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card-content pipeline"
  }, [_c('div', [_vm._m(0), _c('div', {
    staticClass: "divider-margin"
  }), _vm._l(_vm.mortgagesGetterComp.vyber_riesenia, function (mortgage, key) {
    return _c('hypoteka-item-detail', {
      key: key,
      attrs: {
        "mortgage": mortgage,
        "client": mortgage.applicant,
        "stage": 'vyber_riesenia',
        "active-delete-button": _vm.show
      },
      on: {
        "remove-mortgage": function removeMortgage($event) {
          return _vm.removeMortgage(mortgage);
        },
        "pause-mortgage": function pauseMortgage($event) {
          return _vm.pauseMortgage(mortgage);
        },
        "renew-mortgage": function renewMortgage($event) {
          return _vm.renewMortgage(mortgage);
        }
      }
    });
  }), _vm.shouldDisplayNextPageButton('vyber_riesenia') ? _c('div', {
    staticClass: "m-3 d-flex justify-content-center align-items-center"
  }, [_vm.loading.vyber_riesenia ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('span', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.nextPage('vyber_riesenia');
      }
    }
  }, [_vm._v(" + načítaj ďalšie ")])]) : _vm._e()], 2), _c('div', [_vm._m(1), _c('div', {
    staticClass: "divider-margin"
  }), _vm._l(_vm.mortgagesGetterComp.kompletizacia_podkladov, function (mortgage, key) {
    return _c('hypoteka-item-detail', {
      key: key,
      attrs: {
        "mortgage": mortgage,
        "client": mortgage.applicant,
        "stage": 'kompletizacia_podkladov',
        "active-delete-button": _vm.show
      },
      on: {
        "remove-mortgage": function removeMortgage($event) {
          return _vm.removeMortgage(mortgage);
        },
        "pause-mortgage": function pauseMortgage($event) {
          return _vm.pauseMortgage(mortgage);
        },
        "renew-mortgage": function renewMortgage($event) {
          return _vm.renewMortgage(mortgage);
        }
      }
    });
  }), _vm.shouldDisplayNextPageButton('kompletizacia_podkladov') ? _c('div', {
    staticClass: "m-3 d-flex justify-content-center align-items-center"
  }, [_vm.loading.kompletizacia_podkladov ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('span', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.nextPage('kompletizacia_podkladov');
      }
    }
  }, [_vm._v(" + načítaj ďalšie ")])]) : _vm._e()], 2), _c('div', [_vm._m(2), _c('div', {
    staticClass: "divider-margin"
  }), _vm._l(_vm.mortgagesGetterComp.schvalovanie, function (mortgage, key) {
    return _c('hypoteka-item-detail', {
      key: key,
      attrs: {
        "mortgage": mortgage,
        "client": mortgage.applicant,
        "stage": 'schvalovanie',
        "active-delete-button": _vm.show
      },
      on: {
        "remove-mortgage": function removeMortgage($event) {
          return _vm.removeMortgage(mortgage);
        },
        "pause-mortgage": function pauseMortgage($event) {
          return _vm.pauseMortgage(mortgage);
        },
        "renew-mortgage": function renewMortgage($event) {
          return _vm.renewMortgage(mortgage);
        }
      }
    });
  }), _vm.shouldDisplayNextPageButton('schvalovanie') ? _c('div', {
    staticClass: "m-3 d-flex justify-content-center align-items-center"
  }, [_vm.loading.schvalovanie ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('span', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.nextPage('schvalovanie');
      }
    }
  }, [_vm._v(" + načítaj ďalšie ")])]) : _vm._e()], 2), _c('div', [_vm._m(3), _c('div', {
    staticClass: "divider-margin"
  }), _vm._l(_vm.mortgagesGetterComp.cerpana, function (mortgage, key) {
    return _c('hypoteka-item-detail', {
      key: key,
      attrs: {
        "mortgage": mortgage,
        "client": mortgage.applicant,
        "stage": 'cerpana',
        "active-delete-button": _vm.show
      },
      on: {
        "remove-mortgage": function removeMortgage($event) {
          return _vm.removeMortgage(mortgage);
        },
        "pause-mortgage": function pauseMortgage($event) {
          return _vm.pauseMortgage(mortgage);
        },
        "renew-mortgage": function renewMortgage($event) {
          return _vm.renewMortgage(mortgage);
        }
      }
    });
  }), _vm.shouldDisplayNextPageButton('cerpana') ? _c('div', {
    staticClass: "m-3 d-flex justify-content-center align-items-center"
  }, [_vm.loading.cerpana ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _c('span', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.nextPage('cerpana');
      }
    }
  }, [_vm._v(" + načítaj ďalšie ")])]) : _vm._e()], 2), _c('objects-remove-pop-up', {
    attrs: {
      "objects-component": 'MortgageObjects',
      "show": _vm.show,
      "objects": [].concat(_vm.mortgagesGetterComp.zrusena, _vm.mortgagesGetterComp.prehrana)
    },
    on: {
      "restore": function restore($event) {
        return _vm.restoreApplication($event);
      }
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "column-title"
  }, [_c('div', {
    staticClass: "div-block-110 bordered"
  }, [_c('div', {
    staticClass: "text-block-15"
  }, [_vm._v("1")])]), _c('div', {
    staticClass: "bold"
  }, [_vm._v("VÝBER")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "column-title"
  }, [_c('div', {
    staticClass: "div-block-110 bordered"
  }, [_c('div', {
    staticClass: "text-block-15"
  }, [_vm._v("2")])]), _c('div', {
    staticClass: "bold"
  }, [_vm._v("PRÍPRAVA")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "column-title"
  }, [_c('div', {
    staticClass: "div-block-110 bordered"
  }, [_c('div', {
    staticClass: "text-block-15"
  }, [_vm._v("3")])]), _c('div', {
    staticClass: "bold"
  }, [_vm._v("SCHVAĽOVANIE")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "column-title"
  }, [_c('div', {
    staticClass: "div-block-110 bordered"
  }, [_c('div', {
    staticClass: "text-block-15"
  }, [_vm._v("4")])]), _c('div', {
    staticClass: "bold"
  }, [_vm._v("ČERPANIE")])]);

}]

export { render, staticRenderFns }